import { createAction, props } from "@ngrx/store";

export const SetEditingProfileId = createAction("[ESIM] SET_EDITING_PROFILE_ID", props<{ profileId: number }>());

export const SetWizardNavState = createAction(
  "[ESIM] SET_WIZARD_NAV_STATE",
  props<{ wizardLoadedSectionKey: string; wizardLoadedSubSectionKey: string }>()
);

export const SetOverrideNavigationControls = createAction(
  "[ESIM] SET_OVERRIDE_NAVIGATION_CONTROLS",
  props<{ overrideNavigationControls: boolean }>()
);

export const SetOverrideNavigationBackTriggered = createAction(
  "[ESIM] SET_OVERRIDE_NAVIGATION_BACK_TRIGGERED",
  props<{ overrideNavigationBackTriggered: boolean }>()
);

export const SetOverrideNavigationNextTriggered = createAction(
  "[ESIM] SET_OVERRIDE_NAVIGATION_NEXT_TRIGGERED",
  props<{ overrideNavigationNextTriggered: boolean }>()
);

export const SetNewExpertProfileOptions = createAction(
  "[ESIM] SET_NEW_EXPERT_PROFILE_OPTIONS",
  props<{ profileType: string; schemaSelectionOption: any }>()
);

export const SetExpertUnsavedChanges = createAction("[ESIM] SET_EXPERT_UNSAVED_CHANGES", props<{ unsavedChanges: boolean }>());
